var render = function render(){var _vm=this,_c=_vm._self._c;return _c('container-data-input-card',{attrs:{"value":_vm.contact,"config":_vm.config,"blocked":_vm.block,"is-single":"","can-close-enter":"","saving":_vm.saving,"error":_vm.error},on:{"change-data":function($event){return _vm.saveContact($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }